'use strict';

function SearchPortalDirective($stateParams, CompanyGroupService) {
  return {
    restrict: 'EA',
    scope: {
      currentPortals: '='
    },
    replace: true,
    link: function(scope) {
      scope.queryPortals = function(text) {
        CompanyGroupService.query({
          companyId: $stateParams.companyId,
          q: text,
          type: 'VISIBLE',
          limit: 10
        }, function(resp){
          scope.portals = resp.filter(function(g){
            return !scope.currentPortals.some(function(c){
              return c.id === g.id;
            });
          });
        });
      };

      scope.addPortal = function(portal) {
        scope.currentPortals.push(portal);
        scope.portals.splice(scope.portals.indexOf(portal), 1);
      };

      scope.removePortal = function(portal) {
        scope.currentPortals.splice(scope.currentPortals.indexOf(portal), 1);
      };
    },
    templateUrl: 'partials/company/email-to-object/search-portal.html'
  };
}

angular.module('dokiv')
  .directive('searchPortal', ['$stateParams', 'CompanyGroupService', SearchPortalDirective]);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/email-to-object/SearchPortalDirective.js
// module id = 59
// module chunks = 0